import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    DEFAULT_NUMBER_OF_RECS_TO_SHOW,
    NUMBER_OF_RECOMMENDATIONS_TO_FETCH,
} from "./constants";
import LayoutFactory from "../LayoutFactory/component";
import { SectionHeading } from "../Heading/component";
import { getPlaceholderItems } from "../LayoutFactory/component";
import { fetchVideoRecommendations } from "./utils";
import log from "../../utils/logger/library";
import { CardVariantsEnum } from "../../utils/dataTransform/ContentQueryWidget/types";
import useMounted from "../../hooks/useMounted";
import { DEFAULT_SWIMLANE_LAYOUT } from "../LayoutFactory/constants";

export const VideoRecommendations = ({
    layout = DEFAULT_SWIMLANE_LAYOUT,
    featureAttributionData,
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [recommendedClips, setRecommendedClips] = useState([]);
    const path = useSelector((state) => state.app.path);
    const contentId = useSelector((state) => state.app.contentId);
    const isMounted = useMounted();
    const {
        columns = DEFAULT_NUMBER_OF_RECS_TO_SHOW,
        rows = 1,
        variant = CardVariantsEnum.STANDARD,
    } = layout;
    const numOfItemsToShow = columns * rows || DEFAULT_NUMBER_OF_RECS_TO_SHOW;

    const fetchRecommendedItems = async () => {
        let items = [];
        try {
            setIsLoading(true);

            items = await fetchVideoRecommendations(
                NUMBER_OF_RECOMMENDATIONS_TO_FETCH,
                path,
                contentId,
                layout
            );
        } catch (error) {
            items = [];
            log.error(
                `(VideoRecommendations) fetch recommended clips failed`,
                error
            );
        }

        setRecommendedClips(items);
        setIsLoading(false);
    };

    useEffect(() => {
        if (!isMounted) return;
        contentId && fetchRecommendedItems();
    }, [path, contentId, isMounted]);

    const getPlaceHolderOrRecItems = () => {
        return isLoading
            ? getPlaceholderItems(numOfItemsToShow, variant)
            : recommendedClips.slice(0, numOfItemsToShow);
    };

    return isLoading || recommendedClips?.length ? (
        <div
            className="video-recommendations"
            data-testid="video-recommendations"
        >
            <SectionHeading text="Recommended for You" />
            <LayoutFactory
                layout={layout}
                items={getPlaceHolderOrRecItems()}
                featureAttributionData={featureAttributionData}
            />
        </div>
    ) : null;
};

export default VideoRecommendations;

VideoRecommendations.propTypes = {
    layout: PropTypes.shape({
        columns: PropTypes.number,
        rows: PropTypes.number,
        variant: PropTypes.string,
        isFlexible: PropTypes.bool,
    }),
    featureAttributionData: PropTypes.shape({
        instance: PropTypes.string,
        name: PropTypes.string,
    }),
};
